"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalFootnotes = void 0;
const equalFootnotes = (deps, prevDeps) => {
    if (!prevDeps) {
        return false;
    }
    return (prevDeps.length === deps.length &&
        prevDeps.every((prevDep, index) => prevDep.Text === deps[index].Text && prevDep.Key === deps[index].Key));
};
exports.equalFootnotes = equalFootnotes;
//# sourceMappingURL=EqualFootnotes.js.map